export function remain_time(time) {
    let remain_time = '00:00:00';
    if (time > 0) {
        const date_time = 60 * 60 * 24;
        let left_second = time;
        let day = Math.floor(left_second / date_time);
        const day_time = day * date_time;
        let hour = Math.floor((left_second - day_time) / 3600);
        const hour_time = hour * 3600;
        let minute = Math.floor((left_second - day_time - hour_time) / 60);
        let second = Math.floor(
            left_second - day_time - hour_time - minute * 60
        );
        hour = hour > 9 ? hour : '0' + hour;
        minute = minute > 9 ? minute : '0' + minute;
        second = second > 9 ? second : '0' + second;
        remain_time = hour + ':' + minute + ':' + second + ':' + day;
    }
    return remain_time;
}

export function round_down(number, precision) {
    let fig = Math.pow(10, precision);
    return Math.floor((number + 0.000001) * fig) / fig;
}

export function round(number, precision) {
    let temp_number = (number * 100) % 100;

    if (temp_number === 0 || parseInt(temp_number) === temp_number) {
        return number.toFixed(2);
    }

    let factor = Math.pow(10, precision);
    temp_number = number * factor;
    let rounded_temp_number = Math.round(temp_number);

    return rounded_temp_number / factor;
}

export function getlocalStorage(key, _default) {
    let value = window.localStorage.getItem(key);
    if (value !== null) {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value;
    }
    _default = typeof _default !== 'undefined' ? _default : 1;
    return _default;
}

export function setlocalStorage(key, value) {
    if (typeof value !== 'undefined') {
        window.localStorage.setItem(key, value);
    }
}
export function getSessionStorage(key, _default) {
    let value = window.sessionStorage.getItem(key);
    if (value !== null) {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value;
    }
    _default = typeof _default !== 'undefined' ? _default : 1;
    return _default;
}

export function setSessionStorage(key, value) {
    if (typeof value !== 'undefined') {
        window.sessionStorage.setItem(key, value);
    }
}


//生成从minNum到maxNum的随机数
export function get_random_num(minNum,maxNum){ 
    switch(arguments.length){ 
        case 1: 
            return parseInt(Math.random()*minNum+1,10); 
        break; 
        case 2: 
            return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
        break; 
            default: 
                return 0; 
            break; 
    } 
}

/* 时间戳转换成日期
 * @param timestamp
 * @returns {*}
 */
export function timestampToTime(timestamp) {
    var now = new Date(Number(timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    let date = now.getDate();
    let hour = now.getHours();
    let minute = now.getMinutes();
    let second = now.getSeconds();

    if (month <= 9) {
        month = '0' + month;
    }
    if (date <= 9) {
        date = '0' + date;
    }
    if (hour <= 9) {
        hour = '0' + hour;
    }
    if (minute <= 9) {
        minute = '0' + minute;
    }
    if (second <= 9) {
        second = '0' + second;
    }

    return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second;
}
export function trim(str){
　　return str.replace(/(^\s*)|(\s*$)/g, "");
}


// WEBPACK FOOTER //
// ./src/utils/common.js